<template>
  <HPopup class="h-mode-role-selector"
          ref="popup"
          :closeOnClickModal="false"
          :zIndex="zIndex"
          :visible.sync="visible">
    <div class="h-mode-role-selector-container">
      <div class="header h-outer-border around-4 bz1 h-bg brown-2">
        选择角色
        <span class="config-author h-title nowrap"
              data-title="角色数据由 @土八兔 提供支持">Powered by @土八兔</span>
      </div>
      <!-- 英雄列表 -->
      <div class="role-list">
        <button v-click-sound-button class="h-btn LEFTARN" :disabled="prevDisable" @click="handlePrev"></button>
        <div class="rol-list-wrapper">
          <div v-click-sound-button
               class="role-item h-outer-border around-4 bw3 bz0"
               :class="{ selected: selectedHeroIndex === index }"
               v-for="(item, index) in listRoleHeroes" :key="item.name"
               @click="selectedHeroIndex=index">
            <div class="hero-avatar">
              <img :src="item.avatar" alt="">
            </div>
            <div class="hero-name">{{ item.nameCn }}</div>
          </div>
        </div>
        <button v-click-sound-button class="h-btn RIGHTARN" :disabled="nextDisable" @click="handleNext"></button>
      </div>
      <!-- 英雄信息 -->
      <div v-if="hero" class="hero-info-box h-outer-border around-1">
        <div class="role-info">
          <div class="col-left">
            <div class="hero-info">
              <div class="avatar h-outer-border around-4 bw2 bz0">
                <img :src="hero.avatar" alt="">
              </div>
              <div class="hero-name h-outer-border around-4 bw2 bz0 h-bg brown-2">
                <p class="name">{{ hero.nameCn }}</p>
                <p class="class">{{ hero.heroClassCn }}</p>
              </div>
            </div>
            <!-- primary skills -->
            <div class="primary-skills-info">
              <div class="text-row desc h-outer-border around-4 bw2 bz0 h-bg brown-2">
                <p>攻击力</p>
                <p>防御力</p>
                <p>力量</p>
                <p>知识</p>
              </div>
              <div class="icon-row">
                <div class="h-outer-border around-4 bw2 bz0">
                  <img :src="`${$rHost}/img/ui/PSKIL42A.jpg`" alt="">
                </div>
                <div class="h-outer-border around-4 bw2 bz0">
                  <img :src="`${$rHost}/img/ui/PSKIL42D.jpg`" alt="">
                </div>
                <div class="h-outer-border around-4 bw2 bz0">
                  <img :src="`${$rHost}/img/ui/PSKIL42P.jpg`" alt="">
                </div>
                <div class="h-outer-border around-4 bw2 bz0">
                  <img :src="`${$rHost}/img/ui/PSKIL42K.jpg`" alt="">
                </div>
              </div>
              <div class="text-row value h-outer-border around-4 bw2 bz0 h-bg brown-2">
                <p>{{ hero.attack }}</p>
                <p>{{ hero.defense }}</p>
                <p>{{ hero.power }}</p>
                <p>{{ hero.knowledge }}</p>
              </div>
            </div>
            <div class="morale-luck">
              <div class="morale h-outer-border around-4 bw2 bz0">
                <img :src="moraleUrl(heroMorale)" alt="">
              </div>
              <div class="luck h-outer-border around-4 bw2 bz0">
                <img :title="heroLuck" :src="luckUrl(heroLuck)" alt="">
              </div>
              <div class="mana h-outer-border around-4 bw2 bz0">
                <img :src="`${$rHost}/img/ui/SPOINTS.jpg`" alt="">
                <p class="mana-value">{{ ~~(hero.knowledge * 10 * manaFactor) }}</p>
              </div>
            </div>
          </div>
          <div class="col-right">
            <!-- secondary skills -->
            <div class="secondary-skills-info">
              <div class="secondary-skill-item h-bg brown-2"
                   v-for="(level, skillName) in hero.secondarySkills" :key="skillName">
                <div class="icon h-outer-border around-4 bw2 bz0">
                  <img :src="skillIconUrl(skillName, level)" alt="">
                </div>
                <div class="info h-outer-border around-4 bw2 bz0">
                  <p class="level">{{ LEVEL_NAME_MAP[level] }}</p>
                  <p class="name">{{ (secondarySkillsConfig.find(d => d.name === skillName) || {}).nameCn }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="hero-troop h-outer-border around-4 bz1 h-bg brown-2">
          <HTroopList ref="troopList" :allowMerge="false" :troopData="troop"></HTroopList>
        </div>
      </div>
      <div class="buttons">
        <div v-click-sound-button class="h-btn MUBCHCKN" @click="handleConfirm"></div>
        <div v-click-sound-button class="h-btn MUBCANCN" @click="handleCancel"></div>
      </div>
    </div>
  </HPopup>

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import HPopup from '@/components/h-popup'
import secondarySkillsConfig from '@js/config/resource/secondary-skills-config'
import HTroopList from '@/components/h-troop-list'

const LEVEL_NAME_MAP = {
  1: '初级',
  2: '中级',
  3: '高级',
}

export default {
  data () {
    return {
      LEVEL_NAME_MAP,
      secondarySkillsConfig,
      intelligenceFactor: {
        1: 1.25,
        2: 1.5,
        3: 2,
      },
      roleHeroes: [],
      selectedHeroIndex: 0,
      pager: {
        pageNum: 0,
        pageSize: 10,
        total: 0
      }
    }
  },

  props: {
    visible: {
      type: Boolean,
      default: true
    },
    zIndex: {
      type: Number,
      default: 1000
    },
  },

  computed: {
    ...mapGetters('device', [
      'isMobile',
    ]),

    prevDisable () {
      return this.pager.pageNum <= 0
    },

    nextDisable () {
      return this.pager.pageNum >= Math.ceil(this.pager.total / this.pager.pageSize) - 1
    },

    listRoleHeroes () {
      const start = this.pager.pageNum * this.pager.pageSize
      const end = (this.pager.pageNum + 1) * this.pager.pageSize
      return this.roleHeroes.slice(start, end)
    },

    hero () {
      return this.listRoleHeroes[this.selectedHeroIndex]
    },

    heroMorale () {
      return +this.hero?.secondarySkills?.Leadership || 0
    },

    heroLuck () {
      return +this.hero?.secondarySkills?.Luck || 0
    },

    troop () {
      return this.hero?.troop || []
    },

    manaFactor () {
      if (!this.hero) {
        return 1
      }
      return this.intelligenceFactor[+this.hero.secondarySkills.Intelligence] || 1
    },
  },

  mounted () {
    this.getRoleHeroesData()
  },

  methods: {
    ...mapActions('gameData', [
      'getRoleHeroes',
    ]),

    moraleUrl (morale = 0) {
      if (morale < 0) {
        return `${this.$rHost}/img/common/morale/IMRL42B${Math.abs(parseInt(morale))}.jpg`
      }
      return `${this.$rHost}/img/common/morale/IMRL42G${parseInt(morale)}.jpg`
    },

    luckUrl (luck = 0) {
      return `${this.$rHost}/img/common/luck/ILCK42G${parseInt(luck)}.jpg`
    },

    getSkillLevel (name) {
      return +this.secondarySkills[name] || 0
    },

    skillIconUrl (name, level) {
      const source = secondarySkillsConfig.find((d) => d.name === name)?.sourceName
      const sourceName = source + (['A', 'A', 'B', 'C'][level] || '')
      return `${this.$rHost}/img/common/secondary_skill/${sourceName}.jpg`
    },

    async getRoleHeroesData () {
      try {
        this.roleHeroes = await this.getRoleHeroes()
        this.pager.total = this.roleHeroes.length
      } catch (err) {
        console.error(err)
      }
    },

    handlePrev () {
      if (this.prevDisable) {
        return
      }
      this.pager.pageNum = Math.max(this.pager.pageNum - 1, 0)
      this.selectedHeroIndex = 0
    },

    handleNext () {
      if (this.nextDisable) {
        return
      }
      this.pager.pageNum = Math.min(
        this.pager.pageNum + 1,
        Math.ceil(this.pager.total / this.pager.pageNum) - 1)
      this.selectedHeroIndex = 0
    },

    closePopup () {
      this.$emit('close', false)
    },

    handleConfirm () {
      this.$emit('select', {
        name: this.hero.name,
        nameCn: this.hero.nameCn,
        avatar: this.hero.avatar,
        troop: this.$refs.troopList.getTroop(),
      })
    },

    handleCancel () {
      this.closePopup()
    },
  },

  components: {
    HPopup,
    HTroopList,
  }
}
</script>

<style lang="stylus" scoped>
  .h-mode-role-selector
    position absolute

  .hero-troop
    margin-top 10px
    padding 5px 15px

  .secondary-skills-info
    display flex
    justify-content space-around
    flex-wrap wrap
    place-content flex-start
    .secondary-skill-item
      display flex
      width calc(50% - 1px)
      whiteText1()
      > .icon
        width 54px
        img
          max-width 100%
          vertical-align top
      > .info
        flex-grow 1
        padding 5px 10px
        display flex
        flex-direction column
        justify-content space-around
        font-size 14px
      &:nth-child(2n)
        margin-left 2px
      &:nth-child(n + 3)
        margin-top 2px

  .hero-info-box
    margin-top 10px
    padding 2px
    border-width 6px

  .role-info
    display flex
    justify-content space-between
    .col-left,
    .col-right
      width calc(50% - 3px)
      display flex
      flex-direction column

  .hero-info
    display flex
    .avatar
      overflow hidden
      display flex
      justify-content center
      align-items center
      width 70px
      height 77px
      img
        width 100%
        vertical-align top
    .hero-name
      display flex
      flex-direction column
      justify-content center
      align-items center
      margin-left 5px
      width calc(100% - 75px)
      .name
        font-size 16px
        letter-spacing 2px
        goldText()
      .class
        margin-top 5px
        font-size 14px
        letter-spacing 1px
        whiteText1()

  .morale-luck
    display flex
    justify-content center
    margin-top 10px
    .morale,
    .luck
      width 55px
      height 50px
      padding 2px
      margin-right 2px
      img
        max-width 100%
        vertical-align top
    .mana
      position relative
      text-align center
      width 55px
      height 50px
      padding 2px
      margin-right 2px
      img
        width 100%
        height 35px
        vertical-align top
      .mana-value
        position absolute
        width calc(100% - 4px)
        left 2px
        bottom 2px
        line-height 16px
        font-size 12px
        letter-spacing 1px
        background-color rgba(0, 0, 0, 0.3)
        whiteText1()

  .primary-skills-info
    margin-top 10px
    .icon-row
      margin-top 2px
      margin-bottom 2px
      display flex
      justify-content space-around
      > div
        width 60px
        padding 2px
        > img
          max-width 100%
          vertical-align top
    .text-row
      display flex
      > p
        width 25%
        line-height 22px
        font-size 14px
        text-align center
        letter-spacing 1px
        goldText1()
    .text-row.value > p
      whiteText1()

  .h-mode-role-selector-container
    width 650px
    > .header
      position relative
      margin-bottom 10px
      line-height 36px
      text-align center
      letter-spacing 5px
      goldText()
    .config-author
      position absolute
      z-index 1
      right 5px
      top 50%
      font-size 12px
      whiteText1()
      letter-spacing 1px
      transform translateY(-50%)
      &:hover
        goldText()

  /*  角色列表 */
  .role-list
    display flex
    justify-content space-evenly
    .h-btn.LEFTARN,
    .h-btn.RIGHTARN
      width 27px
      height 56px
      border 2px solid $colorGold
    .rol-list-wrapper
      display flex
      width 575px
    .role-item
      position relative
      padding 3px
      filter grayscale(0.9)
      .hero-avatar
        overflow hidden
        display flex
        align-items center
        justify-content center
        width 50px
        height 50px
        img
          width 100%
          vertical-align top
      .hero-name
        position absolute
        left 3px
        bottom 3px
        width calc(100% - 6px)
        line-height 20px
        font-size 12px
        letter-spacing 1px
        text-align center
        background-color rgba(0, 0, 0, 0.5)
        opacity 0
        goldText1()
      &:not(:last-child)
        margin-right 2px
      &:hover
        cursor pointer
      &.selected
        outline 2px solid $colorLightBlue
        filter grayscale(0)

  .buttons
    display flex
    justify-content center
    margin-top 15px
    .h-btn:first-child
      margin-right 50px

</style>
